module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n   " + _vm._s(_vm.actionToBePerformed) + "\n  ")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.country_id.required
    },
    attrs: {
      "id": "country_id"
    },
    on: {
      "change": _vm.selectedCountry
    },
    model: {
      value: (_vm.gRowObj.country_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "country_id", $$v)
      },
      expression: "gRowObj.country_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Country--")]), _vm._v(" "), _vm._l((_vm.countryList), function(data) {
    return _c('option', {
      key: data.country_id,
      domProps: {
        "selected": data.country_id === _vm.gRowObj.country_id,
        "value": data.country_id
      }
    }, [_vm._v(_vm._s(data.country_name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.country_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a country.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.client_id.required
    },
    attrs: {
      "id": "client_id"
    },
    on: {
      "change": _vm.selectedClient
    },
    model: {
      value: (_vm.gRowObj.client_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "client_id", $$v)
      },
      expression: "gRowObj.client_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Customer--")]), _vm._v(" "), _vm._l((_vm.clientList), function(data) {
    return _c('option', {
      key: data.id,
      domProps: {
        "value": data.id,
        "selected": data.id === _vm.gRowObj.client_id
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.client_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a client.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Google Sheet URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.spreadsheetURL),
      expression: "gRowObj.spreadsheetURL"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.spreadsheetURL.required
    },
    attrs: {
      "type": "text",
      "id": "spreadsheetURL",
      "placeholder": "Google Sheet URL"
    },
    domProps: {
      "value": (_vm.gRowObj.spreadsheetURL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "spreadsheetURL", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.spreadsheetURL.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter URL of Google Sheet.")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('ul', [_vm._m(3), _vm._v(" "), _vm._l((_vm.refAccessData), function(access, index) {
    return _c('li', {
      key: index,
      staticClass: "radio-inline"
    }, [_c('label', {
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.ref_access),
        expression: "gRowObj.ref_access"
      }],
      attrs: {
        "type": "radio",
        "name": "ref_access",
        "disabled": ""
      },
      domProps: {
        "value": access.id,
        "checked": _vm.gRowObj.ref_access,
        "checked": _vm._q(_vm.gRowObj.ref_access, access.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.gRowObj, "ref_access", access.id)
        }
      }
    }), _vm._v(_vm._s(access.type_name) + "\n                        ")])])
  })], 2), _vm._v(" "), _c('ul', [_vm._m(4), _vm._v(" "), _vm._l((_vm.refOwnershipData), function(ownership, index) {
    return _c('li', {
      key: index,
      staticClass: "radio-inline"
    }, [_c('label', {
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.ref_ownership),
        expression: "gRowObj.ref_ownership"
      }],
      attrs: {
        "type": "radio",
        "name": "ref_ownership"
      },
      domProps: {
        "value": ownership.id,
        "checked": _vm.gRowObj.ref_ownership,
        "checked": _vm._q(_vm.gRowObj.ref_ownership, ownership.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.gRowObj, "ref_ownership", ownership.id)
        }
      }
    }), _vm._v(_vm._s(ownership.type_name) + "\n                        ")])])
  })], 2), _vm._v(" "), _c('ul', [_vm._m(5), _vm._v(" "), _vm._l((_vm.refServiceData), function(service, index) {
    return _c('li', {
      key: index,
      staticClass: "radio-inline"
    }, [_c('label', {
      staticClass: "radio-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.ref_service),
        expression: "gRowObj.ref_service"
      }],
      attrs: {
        "type": "radio",
        "name": "ref_service"
      },
      domProps: {
        "value": service.id,
        "checked": _vm.gRowObj.ref_service,
        "checked": _vm._q(_vm.gRowObj.ref_service, service.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.gRowObj, "ref_service", service.id)
        }
      }
    }), _vm._v(_vm._s(service.type_name) + "\n                        ")])])
  })], 2), _vm._v(" "), (_vm.submitted && (!_vm.$v.gRowObj.ref_service.required || !_vm.$v.gRowObj.ref_ownership.required || !_vm.$v.gRowObj.ref_access.required)) ? _c('span', {
    staticClass: "text-red",
    staticStyle: {
      "margin-left": "60px"
    }
  }, [_vm._v("Please select the resource type.")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-6"
  }, [_vm._m(7), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline padding-botton-15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelectedServices),
      expression: "allSelectedServices"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelectedServices) ? _vm._i(_vm.allSelectedServices, null) > -1 : (_vm.allSelectedServices)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.allSelectedServices,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelectedServices = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allSelectedServices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelectedServices = $$c
        }
      }, function($event) {
        return _vm.selectAllServices('service')
      }]
    }
  }), _vm._v(" Select All")]), _vm._v(" "), _vm._l((_vm.servicesList), function(service) {
    return _c('div', {
      key: service.id
    }, [_c('label', {
      staticClass: "checkbox-inline col-xs-6 col-sm-4 col-md-3 col-lg-6",
      staticStyle: {
        "display": "inline-table"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.services),
        expression: "gRowObj.services"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": service.id,
        "checked": Array.isArray(_vm.gRowObj.services) ? _vm._i(_vm.gRowObj.services, service.id) > -1 : (_vm.gRowObj.services)
      },
      on: {
        "click": function($event) {
          return _vm.selectService('service')
        },
        "change": function($event) {
          var $$a = _vm.gRowObj.services,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = service.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.gRowObj, "services", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.gRowObj, "services", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.gRowObj, "services", $$c)
          }
        }
      }
    }), _vm._v(_vm._s(service.legacy_name) + "\n                              ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-6"
  }, [_vm._m(8), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline padding-botton-15px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelectedProducts),
      expression: "allSelectedProducts"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelectedProducts) ? _vm._i(_vm.allSelectedProducts, null) > -1 : (_vm.allSelectedProducts)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.allSelectedProducts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelectedProducts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allSelectedProducts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelectedProducts = $$c
        }
      }, function($event) {
        return _vm.selectAllServices('product')
      }]
    }
  }), _vm._v(" Select All")]), _vm._v(" "), _vm._l((_vm.productList), function(data) {
    return _c('div', {
      key: data.id
    }, [_c('label', {
      staticClass: "checkbox-inline col-xs-6 col-sm-4 col-md-3 col-lg-6",
      staticStyle: {
        "display": "inline-table"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.gRowObj.products),
        expression: "gRowObj.products"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data.id,
        "checked": Array.isArray(_vm.gRowObj.products) ? _vm._i(_vm.gRowObj.products, data.id) > -1 : (_vm.gRowObj.products)
      },
      on: {
        "click": function($event) {
          return _vm.selectService('product')
        },
        "change": function($event) {
          var $$a = _vm.gRowObj.products,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.gRowObj, "products", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.gRowObj, "products", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.gRowObj, "products", $$c)
          }
        }
      }
    }), _vm._v(_vm._s(data.legacy_name) + "\n                              ")])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.validatePhysicalResources()
      }
    }
  }, [_vm._v("Validate Sheet")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFacilities()
      }
    }
  }, [_vm._v("Upload Facilities from Sheet")])])]), _vm._v(" "), _vm._m(9)])])])])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Configuration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "The keyword and audience query will only work for the country which is selected from this dropdown."
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle required"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-15px v-autocomplete"
  }, [_c('label', {
    attrs: {
      "for": "client"
    }
  }, [_vm._v("Select referral type:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "radio-inline",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('label', [_c('strong', [_vm._v(" Physical/Virtual : ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "radio-inline",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('label', [_c('strong', [_vm._v(" Ownership : ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "radio-inline",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('label', [_c('strong', [_vm._v(" Medical/Pharmacy : ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Products/Services available")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px 10px 30px 10px",
      "font-size": "medium",
      "line-height": "30px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "large"
    },
    attrs: {
      "for": "notes"
    }
  }, [_vm._v("Instructions:-")]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    attrs: {
      "id": "notes"
    }
  }, [_vm._v("Please upload the Google Sheet in this folder :- "), _c('a', {
    attrs: {
      "href": "https://drive.google.com/drive/u/1/folders/1YgMYn97VXx7Uu2gon5hWo_PKotWvYlMg",
      "target": "_blank"
    }
  }, [_vm._v("https://drive.google.com/drive/u/1/folders/1YgMYn97VXx7Uu2gon5hWo_PKotWvYlMg")])])]), _vm._v(" "), _c('li', [_c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("CAUTION: ")]), _vm._v("The google sheet which needs to be uploaded should only contains the details in a specific format.\n                    "), _c('ul', [_c('li', [_c('b', [_vm._v("Facility Name")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Latitude")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Longitude")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Address")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Phone Number")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Keyword")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Facility Type")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Pincode")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("administrative_area_level_1")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("administrative_area_level_2")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("administrative_area_level_3")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("locality")])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("formatted_address")])])])]), _vm._v(" "), _c('li', [_vm._v("The sequence of the data must be followed as shown in the sheet and above format.")]), _vm._v(" "), _c('li', [_c('div', {
    attrs: {
      "id": "referenceSheet"
    }
  }, [_vm._v("Here is a demo sheet for your reference :- "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/spreadsheets/d/1FZEkxKqis1Dl35TkUp6u1Eu3yMsYFduGJNVAwxnbOzA/edit?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("https://docs.google.com/spreadsheets/d/1FZEkxKqis1Dl35TkUp6u1Eu3yMsYFduGJNVAwxnbOzA/edit?usp=sharing")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-bfc7fd54","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources-management/physical/bulkUploadResources.vue
// module id = u9St
// module chunks = 1